export default __webpack_public_path__ + "static/media/04AW1FEB66.df79b3d8.jpg";